module.exports = __webpack_public_path__ + "static/media/title_kyouiku.4ecb46cc.svg";